

import { Badge, Card, Col, Row, } from 'antd';

import "./stats.css"


const Top5Days = ({ topFive }) => {


    return (

        <Card
            title="Top 5 des piques d’utilisateurs inscrits :"
            style={{ backgroundColor: "white", cursor: "default", boxShadow: "none" }}
            headStyle={{ fontWeight: "400", borderBottom: "0", minHeight: "22px" }}
            bordered={false}


        >

            {
                topFive.map((item, index) => (
                    <Row style={{ marginBottom: "10px" }}>
                        <Col span={2}>
                            <Badge count={index + 1} />
                        </Col>
                        <Col span={8}>
                            {item.period}
                        </Col>
                        <Col span={14} style={{ display: "flex", justifyContent: "flex-end" }}>
                            {item.count}
                        </Col>

                    </Row>
                ))
            }






        </Card>
    );
}

export default Top5Days;